export default __webpack_public_path__ + "static/media/C2.4fbb7cbc.png";